import React from 'react';

import { useIntl } from 'react-intl';

import type { SearchResultType as Type } from '@atlassian/dynamic-cards-search-client/common/types';

import { messages } from './messages';

export type SearchResultTypeProps = {
	type: Type;
};

export const SearchResultType = ({ type }: SearchResultTypeProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const message = messages[type];

	if (!message) {
		return null;
	}

	return <>{formatMessage(message)}</>;
};
